import { BCollapse } from "bootstrap-vue";

export default {
  components: {
    BCollapse,
  },
  props: {
    order: Object,
  },
};
